module.exports = __webpack_public_path__ + "static/media/house-solid-dark.2f5e952f.png";